import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { ComponentPropsWithoutRef, FC, forwardRef } from 'react';
import { Row, RegistryModel } from 'shared/lib';
import { RegistryPaginationControlsEndProps } from './registry-pagination-controls-end';
import { RegistryPaginationControlsNextProps } from './registry-pagination-controls-next';
import { RegistryPaginationControlsPreviousProps } from './registry-pagination-controls-previous';
import { RegistryPaginationControlsStartProps } from './registry-pagination-controls-start';

export type RegistryPaginationControlsProps = ComponentPropsWithoutRef<'div'>;

export const createRegistryPaginationControls = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
	TAdditionalData = unknown,
>(
	model: RegistryModel<TRow, TFilters, TError, TAdditionalData>,
	RegistryPaginationControlsStart: FC<RegistryPaginationControlsStartProps>,
	RegistryPaginationControlsPrevious: FC<RegistryPaginationControlsPreviousProps>,
	RegistryPaginationControlsNext: FC<RegistryPaginationControlsNextProps>,
	RegistryPaginationControlsEnd: FC<RegistryPaginationControlsEndProps>,
) => {
	const RegistryPaginationControls = forwardRef<HTMLDivElement, RegistryPaginationControlsProps>(
		({ className, children, ...props }, ref) => {
			const hidden = useUnit(model.$paginationHidden);

			return (
				!hidden && (
					<div
						ref={ref}
						className={clsx('registry-pagination-controls', className)}
						{...props}
					>
						{children ?? (
							<>
								<RegistryPaginationControlsStart />
								<RegistryPaginationControlsPrevious />
								<RegistryPaginationControlsNext />
								<RegistryPaginationControlsEnd />
							</>
						)}
					</div>
				)
			);
		},
	);

	return RegistryPaginationControls;
};
